import { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import PrivilegesContext from '@ubeya/shared-web/contexts/PrivilegesContext';
import privileges from '@ubeya/shared-web/privileges';

const useContractAccess = () => {
  const {
    enableContractFeature: isContractFeatureEnabledForAccount,
    enableContractLeaveManagementFeature: isContractLeaveManagementEnabledForAccount
  } = useContext(ConfigContext);
  const myPrivileges = useContext(PrivilegesContext);

  const hasContractAccess = !!myPrivileges[privileges.CONTRACT_INFORMATION_ACCESS];

  return {
    hasContractAccess,
    isContractFeatureEnabledForAccount: !!isContractFeatureEnabledForAccount,
    isContractLeaveManagementEnabledForAccount: !!isContractLeaveManagementEnabledForAccount,
    enableContractFeature: !!isContractFeatureEnabledForAccount && hasContractAccess,
    enableContractLeaveManagementFeature: !!isContractLeaveManagementEnabledForAccount && hasContractAccess
  };
};

export default useContractAccess;
